import some from 'lodash/some';
import { ListBooking } from 'types';
import { BookingListContextValue } from '../contextProvider/types';

export const shouldUpdatePaymentMethod = (booking: ListBooking): boolean => {
  // TODO: Remove `notYetMigrateToAdyenPaymentGateway` once all `up coming booking` have been filly migrated to Adyen payment gateway
  const { hasPendingScheduledPayment, isCreditCardExpired, requiresPaymentMethodUpdate } = booking.flags;
  const notYetMigrateToAdyenPaymentGateway = requiresPaymentMethodUpdate;
  return hasPendingScheduledPayment && (isCreditCardExpired || notYetMigrateToAdyenPaymentGateway);
};

export const shouldDisplayPaymentMethodUpdateRequiredAlert = ({ filter, bookings }: Partial<BookingListContextValue>): boolean => {
  const isUpcomingFilter = filter === 'upcoming';
  const hasRequiresPaymentMethodUpdateBooking = some(bookings, shouldUpdatePaymentMethod);
  return isUpcomingFilter && hasRequiresPaymentMethodUpdateBooking;
};
